<template>
  <main-content-wrapper>
    <h1 class="text-md-center">
      PRVA PRIJAVA V NOVO SPLETNO TRGOVINO
      <span>Tuš Cash & Carry celovito varuje vaše podatke. V nadaljevanju boste posodobili vaše trenutno uporabniško ime z e-naslovom.
        <br />V spletno trgovino se boste od sedaj naprej prijavljali z email naslovom in geslom, zato ga skrbno shranite.</span>
    </h1>
    <empty-space/>
    <v-layout justify-center row wrap fill-height>
      <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
        <v-form v-model="valid" @submit.prevent="" ref="form">
          <v-alert
            :value="generalError!=null"
            type="error"
          >
            {{ generalError }}
          </v-alert>
          <h4>Vaš e-naslov za prijavo</h4>
          <email-field v-model="email" required label="Vpišite vaš e-naslov" :error-messages="email_error_messages"
                       :rules="[checkEmail]" ref="email_input" required/>
          <template v-if="askForPassword">
            <empty-space/>
            <h4>Vaše novo geslo</h4>
            <password-field v-model="password" :rules="newPasswordRules" label="Geslo" required/>
            <password-field v-model="password_again" :rules="[checkNewPasswordAgain]" label="Ponovno vpišite geslo"
                            required/>
            <span class="font-italic">Skrbno shranite vaše podatke za prijavo.</span>
          </template>
        </v-form>
        <v-btn depressed large block color="primary_action" @click="sendInvitation()" :loading="loading">Potrditev
        </v-btn>
      </v-flex>
    </v-layout>
  </main-content-wrapper>
</template>

<script>
import MainContentWrapper from '../components/MainContentWrapper'
import EmptySpace from '../components/EmptySpace'
import EmailField from '../components/EmailField'
import { userService } from '../services'
import validations from '../components/validations'
import PasswordField from '@/components/PasswordField.vue'

export default {
  name: 'FirstLoginNewStore',
  components: { PasswordField, MainContentWrapper, EmptySpace, EmailField },
  data: vm => ({
    email: null,
    loading: false,
    generalError: null,
    email_error_messages: null,
    password: null,
    password_again: null,
    newPasswordRules: validations.newPasswordRules,
  }),
  computed: {
    askForPassword () {
      return this.$route.meta.card;
    },
  },
  methods: {
    checkEmail (v) {
      this.email_error_messages = []
      let noError = validations.checkEmailAll(v)
      if (noError === true) {
        userService.checkEmail(v).then(
          data => {
            this.email_error_messages = null
          },
          error => {
            if (error.message) {
              this.email_error_messages = [error.message]
            } else {
              this.email_error_messages = ['Napaka pri preverjanju naslova.']
            }
          }
        )
        return true
      }
      return noError
    },
    sendInvitation () {
      let isValid = this.$refs.form.validate()
      if (isValid && (this.email_error_messages == null || this.email_error_messages.length == 0)) {
        this.generalError = null
        this.loading = true
        userService.sendInvitationOldUser(this.email, this.password).then(
          (data) => {
            this.$store.dispatch('application/emailSentMessage', {
              'title': 'Hvala za zaupane podatke.',
              'text': 'Za dokončanje postopka spremembe uporabniškega imena morate potrditi povezavo v sporočilu, ki smo vam ga poslali na vaš elektronski naslov.'
            })
          },
          (error) => {
            this.generalError = error.message
          }
        ).finally(() => {
          this.loading = false
        })
      }
    },
    checkNewPasswordAgain (v) {
      return validations.newPasswordCheckAgain(v, this.password)
    }
  }
}
</script>

<style scoped>

</style>
